import { render, staticRenderFns } from "./AddExhibitionForm.vue?vue&type=template&id=2ba0f8a8&"
import script from "./AddExhibitionForm.vue?vue&type=script&lang=ts&"
export * from "./AddExhibitionForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddExhibitionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VColorPicker,VIcon,VMenu,VRow,VTextField})
